import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Plus, MapPin, UserRound } from "lucide-react";
import { useAuth, planLabel } from "../../lib/auth";
import InstallApp from "./InstallApp";

function AccountLink() {
  const { user } = useAuth();
  if (!user) {
    return <Link to="/login" className="shrink-0 h-10 md:h-11 px-3 md:px-4 rounded-full bg-[var(--navy)] text-white font-semibold flex items-center gap-1.5 hover:bg-[#123a85] transition-colors" data-testid="header-login-button"><UserRound className="w-4 h-4" /> <span className="hidden sm:inline">Login</span></Link>;
  }
  const active = user.plan_state === "active";
  return (
    <Link to="/account" className="relative shrink-0 flex items-center gap-2 h-10 md:h-11 pl-1 pr-3 rounded-full border border-slate-200 hover:border-[var(--navy)] transition-colors" data-testid="header-account-link">
      {user.stale_ads > 0 && <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-yellow-400 text-[var(--navy)] text-[11px] font-bold flex items-center justify-center" title="30 दिवस जुन्या जाहिराती" data-testid="header-reminder-badge">{user.stale_ads}</span>}
      <span className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-[var(--navy)] text-white font-bold flex items-center justify-center">{user.name[0].toUpperCase()}</span>
      <span className="hidden sm:block leading-tight text-left">
        <span className="block text-sm font-semibold text-[var(--navy)] max-w-[110px] truncate">{user.name}</span>
        <span className={`block text-[11px] font-semibold ${active ? "text-green-700" : "text-[var(--sell)]"}`} data-testid="header-plan-label">{planLabel(user)}</span>
      </span>
    </Link>
  );
}

export const SEARCH_PLACEHOLDER = "संपूर्ण महाराष्ट्रात शोधा - Mobile, Car, Job...";

export function SearchBar({ big = false, testId = "header-search" }) {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    nav(`/buy${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`);
  };
  return (
    <form onSubmit={submit} className={`flex w-full rounded-xl overflow-hidden border-2 border-[var(--navy)] bg-white ${big ? "h-14 md:h-16 shadow-lg" : "h-11"}`} data-testid={`${testId}-form`}>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={SEARCH_PLACEHOLDER}
        className={`flex-1 min-w-0 px-4 outline-none bg-transparent ${big ? "text-base md:text-lg" : "text-sm"}`}
        data-testid={`${testId}-input`}
      />
      <button type="submit" className="bg-[var(--navy)] text-white px-4 md:px-6 flex items-center gap-2 hover:bg-[#123a85] transition-colors" data-testid={`${testId}-button`}>
        <Search className="w-5 h-5" />
        <span className="hidden sm:inline font-semibold">शोधा</span>
      </button>
    </form>
  );
}

export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 h-16 md:h-20 flex items-center gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="header-logo-link">
          <span className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-[var(--orange)] text-white font-display font-extrabold text-xl flex items-center justify-center shadow">99</span>
          <span className="leading-none">
            <span className="block font-display font-extrabold text-lg md:text-xl text-[var(--navy)]">99Bazaar</span>
            <span className="block text-[11px] md:text-xs font-semibold tracking-wider text-[var(--orange)] uppercase">Maharashtra</span>
          </span>
        </Link>
        <div className="hidden md:flex items-center gap-1 text-sm text-slate-600 px-3 h-11 rounded-xl border border-slate-200 shrink-0">
          <MapPin className="w-4 h-4 text-[var(--orange)]" /> महाराष्ट्र
        </div>
        <div className="hidden md:block flex-1"><SearchBar /></div>
        <Link to="/sell" className="ml-auto md:ml-0 shrink-0 flex items-center gap-1.5 rounded-full border-[3px] border-[var(--orange)] px-4 h-10 md:h-11 font-bold text-[var(--navy)] hover:bg-[var(--orange)] hover:text-white transition-colors" data-testid="header-sell-button">
          <Plus className="w-4 h-4" /> SELL
        </Link>
        <InstallApp />
        <AccountLink />
      </div>
      <div className="md:hidden px-4 pb-3"><SearchBar testId="mobile-search" /></div>
    </header>
  );
}
